export type ContactPayload = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';

export const submitContactRequest = async (payload: ContactPayload) => {
  const response = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    let message = 'Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.';
    try {
      const data = await response.json();
      if (typeof data?.message === 'string' && data.message.trim()) {
        message = data.message;
      }
    } catch (error) {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  return response.json().catch(() => ({}));
};
